import React from 'react';
import { graphql } from 'gatsby';
import { TwoColumn as TwoColumnComponent } from '../../../twoColumn/TwoColumn';

export const TwoColumn = ({ data, ...rest }) => {
  const [first, second] = data.areas;
  return (
    <TwoColumnComponent
      centered={data.alignment === 'Centred'}
      columnOneComponents={first?.blockGridItems.map((item) => item.component)}
      columnTwoComponents={second?.blockGridItems.map((item) => item.component)}
      {...rest}
    />
  );
};

export const TwoColumnQuery = graphql`
  fragment TwoColumn on UMBRACO_TwoColumnComponentType {
    alignment
  }
`;
